var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { organizationTypeEntityName, } from '../../../../backend/config/classifiers/OrganizationTypeClassifier/shared';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Status', value: capitalize(props.response.data.status) },
            { label: 'Name', value: props.response.data.name },
        ] }));
};
const formConfig = {
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
    ],
};
const csvFileHeader = ['ID', 'Name', 'Status'];
function mapCsvRowToData(row) {
    var _a, _b, _c;
    const id = ((_a = row.data[0]) !== null && _a !== void 0 ? _a : '').trim();
    const name = ((_b = row.data[1]) !== null && _b !== void 0 ? _b : '').trim();
    const status = ((_c = row.data[2]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
    if (name.length === 0) {
        row.errors.push('Name is required');
    }
    if (status.length === 0) {
        row.errors.push('Status is required');
    }
    switch (status) {
        case 'active':
        case 'deprecated':
        case 'retired':
            break;
        default:
            row.errors.push('Invalid status, expected one of: active, deprecated, retired');
    }
    if (row.errors.length === 0) {
        row.object = {
            id: id,
            data: {
                name: name,
                status: status,
            },
        };
    }
    return Promise.resolve(row);
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return [response.id, response.data.name, response.data.status];
    });
}
export const OrganizationTypeAdminPage = () => {
    return (React.createElement(ClassifierAdminPage, { entity: organizationTypeEntityName, title: 'Organization Type', fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, entityDetailsEditForm: true, entityDetailsPreviewForm: true, formConfig: formConfig, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
